import type { ClassDefinition } from '../../shared/game/class-types.js';

// Berserker 3.0 draft, level 1: Rage and That all you got?!. Intensifying Fury, One with the Ancients, the Savage Arsenal and subclasses come later.
export const berserker: ClassDefinition = {
  id: 'berserker', name: 'Berserker',
  summary: 'A raging, damage-dealing machine whose fury only grows the longer a fight goes on.',
  keyStats: ['strength', 'dexterity'], hitDie: 12, startingHp: 20,
  saves: { advantage: ['strength'], disadvantage: ['intelligence'] },
  armor: [], weapons: ['strength'],
  startingGear: ['Berserker Furs', 'Battleaxe', 'Rations (meat)', 'Rope (50 ft.)'],
  abilities: [
    {
      id: 'rage', name: 'Rage', level: 1, actions: 1, target: 'self', oncePerRound: true, combatOnly: true, autocast: true, rage: { sides: 4 },
      description: 'Roll a Fury Die (d4) and add every Fury Die you hold to your STR attacks. Up to KEY dice; at the limit the lowest is dropped. Rage ends when the fight does, when you drop to 0 HP, or after a round without attacking or Raging. Once per round.',
    },
  ],
  passives: [{
    id: 'that-all-you-got', name: 'That all you got?!', level: 1,
    description: 'When an attack hits you, spend Fury Dice to reduce its damage by STR+DEX for each die.',
  }],
};
